import React, { useState } from 'react';
import Checkbox from "components/checkbox";

// Define la interfaz para los datos de la tabla
interface User {
  name: string;
  email: string;
  username: string;
  joinDate: string;
  userType: string;
  profileImage: string;
}

// Define las props para el componente CheckTable
interface CheckTableProps {
  tableData: User[];
}

// Componente CheckTable
const CheckTable: React.FC<CheckTableProps> = ({ tableData }) => {
  const [selectedUsers, setSelectedUsers] = useState<{ [key: string]: boolean }>({});

  const handleCheckboxChange = (username: string) => {
    setSelectedUsers((prevSelectedUsers) => ({
      ...prevSelectedUsers,
      [username]: !prevSelectedUsers[username],
    }));
  };

  return (
    <div className="p-2">
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white">
          <thead>
            <tr>
              <th className="py-2">Seleccion</th>
              <th className="py-2">Nombre</th>
              <th className="py-2">Email</th>
              <th className="py-2">Username</th>
              <th className="py-2">Fecha</th>
              <th className="py-2">Perfil</th>
              <th className="py-2">Acciones</th>
            </tr>
          </thead>
          <tbody>
            {tableData.map((user, index) => (
              <tr key={index} className="border-t">
                <td className="py-2 text-center">
                  <div className="mb-4 flex items-center px-8">
                    <div className="flex items-center">
                      <Checkbox />
                    </div>
                  </div>
                </td>
                <td className="py-2 flex items-center">
                  {user.name}
                </td>
                <td className="py-2">{user.email}</td>
                <td className="py-2">{user.username}</td>
                <td className="py-2">{user.joinDate}</td>
                <td className="py-2">{user.userType}</td>
                <td className="py-2">
                  <a href="#" className="text-blue-500">
                    Editar Usuario
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

// Componente para el popup de creación de usuario
const UserPopup: React.FC<{ onClose: () => void; onCreate: (user: User) => void }> = ({ onClose, onCreate }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [username, setUsername] = useState('');
  const [joinDate, setJoinDate] = useState('');
  const [userType, setUserType] = useState('Member');
  const [profileImage, setProfileImage] = useState('');

  const handleCreate = () => {
    onCreate({
      name,
      email,
      username,
      joinDate,
      userType,
      profileImage,
    });
    onClose();
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50">
      <div className="bg-white p-8 rounded shadow-lg w-11/12 max-w-2xl">
        <div className="mb-4 border-b">
          <nav className="flex space-x-4">
            <button className="text-blue-500 border-b-2 border-blue-500">Informacion Personal</button>
            <button className="text-gray-500">Domicilio</button>
            <button className="text-gray-500">Perfil</button>
          </nav>
        </div>
        <h2 className="text-2xl mb-4 font-bold">Informacion Personal</h2>
        <form>
          <div className="grid grid-cols-2 gap-4 mb-4">
            <div>
              <label className="block mb-2">Primer Nombre</label>
              <input
                type="text"
                className="w-full p-2 border border-gray-300 rounded"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <div>
              <label className="block mb-2">Segundo Nombre</label>
              <input
                type="text"
                className="w-full p-2 border border-gray-300 rounded"
                value=""
              />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4 mb-4">
            <div>
              <label className="block mb-2">Empresa</label>
              <input
                type="text"
                className="w-full p-2 border border-gray-300 rounded"
                value=""
              />
            </div>
            <div>
              <label className="block mb-2">Email</label>
              <input
                type="email"
                className="w-full p-2 border border-gray-300 rounded"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4 mb-4">
            <div>
              <label className="block mb-2">Contraseña</label>
              <input
                type="password"
                className="w-full p-2 border border-gray-300 rounded"
                value=""
              />
            </div>
            <div>
              <label className="block mb-2">Confirmar Contraseña</label>
              <input
                type="password"
                className="w-full p-2 border border-gray-300 rounded"
                value=""
              />
            </div>
          </div>
          <div className="flex justify-end">
            <button
              type="button"
              className="bg-red-500 text-white px-4 py-2 rounded mr-2"
              onClick={onClose}
            >
              Cancelar
            </button>
            <button
              type="button"
              className="bg-blue-500 text-white px-4 py-2 rounded"
              onClick={handleCreate}
            >
              Siguiente
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

// Componente principal
const Personal: React.FC = () => {
  const [users, setUsers] = useState<User[]>([
    {
      name: "Vlad Mihalache",
      email: "vlad@simmmple.com",
      username: "@vladmihalache",
      joinDate: "Oct 24, 2022",
      userType: "Administrator",
      profileImage: "url_to_image_1"
    },
    {
      name: "Fredy Andrei",
      email: "fredy@simmmple.com",
      username: "@fredyandrei",
      joinDate: "Nov 17, 2019",
      userType: "Administrator",
      profileImage: "url_to_image_2"
    },
    {
      name: "Anonymous User",
      email: "mark@yahoo.com",
      username: "@user0215",
      joinDate: "Jan 30, 2021",
      userType: "Member",
      profileImage: "url_to_image_3"
    },
    {
      name: "Marcus Aurelius",
      email: "markus.a@gmail.com",
      username: "@marcus.aurelius",
      joinDate: "Aug 02, 2021",
      userType: "Member",
      profileImage: "url_to_image_4"
    },
    {
      name: "Lorentz Michael",
      email: "lorentz@gmail.com",
      username: "@lorentz.0002",
      joinDate: "Apr 19, 2021",
      userType: "Member",
      profileImage: "url_to_image_5"
    },
    {
      name: "Tim Wilson",
      email: "wilson.tim@msn.com",
      username: "@wilson.tim21",
      joinDate: "Sep 12, 2021",
      userType: "Member",
      profileImage: "url_to_image_6"
    },
    {
      name: "Vlad Mihalache",
      email: "vlad@simmmple.com",
      username: "@vladmihalache",
      joinDate: "Oct 24, 2022",
      userType: "Administrator",
      profileImage: "url_to_image_1"
    },
    {
      name: "Fredy Andrei",
      email: "fredy@simmmple.com",
      username: "@fredyandrei",
      joinDate: "Nov 17, 2019",
      userType: "Administrator",
      profileImage: "url_to_image_2"
    },
    {
      name: "Anonymous User",
      email: "mark@yahoo.com",
      username: "@user0215",
      joinDate: "Jan 30, 2021",
      userType: "Member",
      profileImage: "url_to_image_3"
    },
    {
      name: "Marcus Aurelius",
      email: "markus.a@gmail.com",
      username: "@marcus.aurelius",
      joinDate: "Aug 02, 2021",
      userType: "Member",
      profileImage: "url_to_image_4"
    },
    {
      name: "Lorentz Michael",
      email: "lorentz@gmail.com",
      username: "@lorentz.0002",
      joinDate: "Apr 19, 2021",
      userType: "Member",
      profileImage: "url_to_image_5"
    },
    {
      name: "Tim Wilson",
      email: "wilson.tim@msn.com",
      username: "@wilson.tim21",
      joinDate: "Sep 12, 2021",
      userType: "Member",
      profileImage: "url_to_image_6"
    },
  ]);

  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const handleCreateUser = (user: User) => {
    setUsers([...users, user]);
  };

  const handleDeleteUser = () => {
    // Implementar lógica para eliminar usuario
  };

  return (
    <div className="mt-5 grid h-full grid-cols-1 gap-5 md:grid-cols-1">
      <div className="flex justify-between mb-4">
        <button
          className="bg-blue-500 text-white px-4 py-2 rounded"
          onClick={() => setIsPopupOpen(true)}
        >
          Crear nuevo usuario
        </button>
        <button
          className="bg-red-500 text-white px-4 py-2 rounded"
          onClick={handleDeleteUser}
        >
          Eliminar usuario
        </button>
      </div>
      <CheckTable tableData={users} />
      {isPopupOpen && (
        <UserPopup
          onClose={() => setIsPopupOpen(false)}
          onCreate={handleCreateUser}
        />
      )}
    </div>
  );
};

export default Personal;
